export default __webpack_public_path__ + "static/image3-7ca3993cae8120da2f52c117b6286871.jpeg";